import { Pages } from 'constants/menu';
import type { SubPage } from 'components/left-submenu/LeftSubmenu';
import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';

interface ContractInformationSubPageOptions {
  campaignState?: CampaignDetailModelState;
  locked?: boolean;
}

export function getContractInformationSubPages({
  campaignState,
  locked = false,
}: ContractInformationSubPageOptions = {}): SubPage[] {
  const subPages: SubPage[] = [
    {
      title: 'Sale Information',
      link: Pages.SALE_INFORMATION,
      locked,
    },
    {
      title: 'Conditions',
      link: Pages.CONDITIONS,
      locked,
    },
  ];

  if (campaignState === CampaignDetailModelState.QLD) {
    subPages.push({
      title: 'Special Conditions',
      link: Pages.SPECIAL_CONDITIONS,
      locked,
    });
  }

  subPages.push(
    {
      title: 'Settlement',
      link: Pages.SETTLEMENT,
      locked,
    },
    {
      title: 'Deposits',
      link: Pages.DEPOSITS,
      locked,
    }
  );

  return subPages;
}
